<template>
  <div>
    <b-modal id="promover-usuario-modal" hide-footer>
      <template #modal-title> Promover Usuário </template>
      <div class="d-block">
        <div class="mb-5 w-100">
          <h6 style="font-size: 0.9rem" class="mt-3 mr-3">Usuário:</h6>
          <AutoComplete
            v-model="selectedUsuario"
            :suggestions="filteredUsuarios"
            @complete="searchUsuario($event)"
            field="usu_login"
            placeholder="Pesquise por ID, nome ou email"
            :delay="500"
            forceSelection
          >
            <template #item="slotProps">
              <div>
                {{ slotProps.item.usuario_id }} -
                {{ slotProps.item.usu_nome }} &lt;{{
                  slotProps.item.usu_login
                }}&gt;
              </div>
            </template>
          </AutoComplete>
          <b-alert v-if="isAdmin" show variant="warning" class="mt-3"
            >Usuário já é um administrador</b-alert
          >
        </div>

        <div class="mb-5">
          <h6 style="font-size: 0.9rem" class="mt-3 mr-3">Grupo:</h6>
          <Dropdown
            v-model="selectedGroup"
            :options="groups"
            optionLabel="name"
            :disabled="permitirSalvar"
            placeholder="Selecione o grupo"
            style="width: 100%"
          />
        </div>

        <div class="">
          <h6 style="font-size: 0.9rem" class="mt-3 mr-3">
            Contas secundárias:
          </h6>
          <MultiSelect
            v-model="selectedContas"
            :options="contasParaTroca"
            optionLabel="login"
            optionValue="id"
            :disabled="permitirSalvar"
            placeholder="Selecione as contas"
            :filter="true"
            style="width: 100%"
          />
        </div>
      </div>
      <b-button
        :disabled="permitirSalvar"
        class="mt-6"
        block
        @click="salvarNovoAdm"
        >Salvar</b-button
      >
    </b-modal>
    <b-modal id="editar-administrador-modal" hide-footer>
      <template #modal-title> Editar Administrador </template>
      <div class="d-block">
        <div class="mb-5">
          <h6 style="font-size: 0.9rem" class="mt-3 mr-3">Grupo:</h6>
          <Dropdown
            v-model="selectedGroup"
            :options="groups"
            optionLabel="name"
            placeholder="Selecione o grupo"
            style="width: 100%"
          />
        </div>

        <div class="">
          <h6 style="font-size: 0.9rem" class="mt-3 mr-3">
            Contas Secundárias:
          </h6>
          <MultiSelect
            v-model="selectedContas"
            :options="contasParaTroca"
            optionLabel="login"
            optionValue="id"
            placeholder="Selecione as contas"
            :filter="true"
            style="width: 100%"
          />
        </div>
      </div>
      <b-button class="mt-6" block @click="salvarAdm">Salvar</b-button>
    </b-modal>
    <div class="card card-custom mt-3 py-5 px-8">
      <div class="d-flex justify-content-between align-items-center">
        <b-input-group size="sm" style="width: 300px">
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Buscar na tabela"
          ></b-form-input>

          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
          </b-input-group-append>
        </b-input-group>

        <!-- Não exibir botão de promover usuário -->
        <button
          v-if="false"
          type="button"
          class="btn btn-sm btn-secondary font-weight-bold mr-2"
          @click="addAdministrador"
        >
          <i class="fa fa-user-plus"></i> Promover usuário
        </button>
      </div>
      <b-table
        :items="administradores"
        :fields="[
          { key: 'usu_nome', label: 'Nome' },
          { key: 'usu_login', label: 'Email' },
          { key: 'cli_nome', label: 'Conta' },
          { key: 'role_description', label: 'Grupo' },
          { key: 'acoes', label: 'Ações' }
        ]"
        :busy="carregando"
        responsive="sm"
        :filter="filter"
        :filter-included-fields="['usu_nome', 'usu_login', 'cli_nome']"
        striped
        hover
        small
        class="mt-3"
      >
        <template #cell(cli_nome)="data">
          <span v-if="data.item.cli_nome">
            {{ data.item.cli_nome }}
          </span>
          <span v-else class="text-muted">Sem conta principal</span>
          <b-badge
            v-b-tooltip.hover
            :title="`Contas acessíveis: ${data.item.contas_secundarias
              .map((c) => c.con_login)
              .join(', ')}`"
            variant="primary"
            class="ml-1"
            v-if="data.item.contas_secundarias.length > 0"
          >
            +{{ data.item.contas_secundarias.length }}</b-badge
          >
        </template>
        <template #cell(acoes)="data">
          <b-button
            size="sm"
            class="btn-icon"
            v-b-tooltip.noninteractive
            title="Editar"
            @click="abrirEdicaoModal(data.item)"
          >
            <i class="fas fa-edit"></i>
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import AdministradorService from "@/core/services/administrador.service";
import { mapGetters } from "vuex";

export default {
  name: "GerenciarAdministradores",
  props: {},

  components: {
    MultiSelect: () => import("primevue/multiselect"),
    Dropdown: () => import("primevue/dropdown"),
    AutoComplete: () => import("primevue/autocomplete")
  },

  data() {
    return {
      administradores: [],
      carregando: true,
      usuarioEmEdicao: {},
      selectedContas: [],
      selectedGroup: null,
      groups: [
        { name: "Usuário", id: 3 },
        { name: "Administrador Geral", id: 10 },
        { name: "Super Administrador", id: 9 }
      ],
      selectedUsuario: null,
      filteredUsuarios: [],
      filter: ""
    };
  },

  mounted() {
    this.obterAdministradores();
  },

  computed: {
    ...mapGetters(["currentUserPersonalInfo", "contasParaTroca"]),
    permitirSalvar() {
      return !this.selectedUsuario || this.isAdmin;
    },
    isAdmin() {
      return [10, 9].includes(this.selectedUsuario?.role_id);
    }
  },

  methods: {
    obterAdministradores() {
      this.carregando = true;

      AdministradorService.getAdministradores()
        .then((response) => {
          this.administradores = response.data;
        })
        .finally(() => {
          this.carregando = false;
        });
    },
    abrirEdicaoModal(usuario) {
      this.usuarioEmEdicao = usuario;
      this.selectedContas = usuario.contas_secundarias.map((c) => c.conta_id);
      this.selectedGroup = {
        name: usuario.role_description,
        id: usuario.role_id
      };
      this.$bvModal.show("editar-administrador-modal");
    },
    addAdministrador() {
      this.$bvModal.show("promover-usuario-modal");
    },
    searchUsuario(search) {
      const busca = search.query;
      AdministradorService.getUsuarios(busca).then((response) => {
        console.log(response.data);
        this.filteredUsuarios = response.data;
      });
    },
    salvarNovoAdm() {
      AdministradorService.trocarGrupo({
        usuario_id: this.selectedUsuario.usuario_id,
        role_id: this.selectedGroup.id
      }).then(() => {
        AdministradorService.contasPermitidas({
          usuario_id: this.selectedUsuario.usuario_id,
          contas: this.selectedContas
        }).then(() => {
          this.$bvModal.hide("promover-usuario-modal");
          this.obterAdministradores();
        });
      });
    },
    salvarAdm() {
      AdministradorService.trocarGrupo({
        usuario_id: this.usuarioEmEdicao.usuario_id,
        role_id: this.selectedGroup.id
      }).then(() => {
        AdministradorService.contasPermitidas({
          usuario_id: this.usuarioEmEdicao.usuario_id,
          contas: this.selectedContas
        }).then(() => {
          this.$bvModal.hide("editar-administrador-modal");
          this.obterAdministradores();
        });
      });
    }
  }
};
</script>

<style scoped>
.holographic-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #000;
}

.holographic-card {
  width: 300px;
  height: 200px;
  background: #111;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  transition: all 0.5s ease;
}

.holographic-card h2 {
  color: #0ff;
  font-size: 2rem;
  position: relative;
  z-index: 2;
}

.holographic-card::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    0deg,
    transparent,
    transparent 30%,
    rgba(0, 255, 255, 0.3)
  );
  transform: rotate(-45deg);
  transition: all 0.5s ease;
  opacity: 0;
}

.holographic-card:hover {
  transform: scale(1.05);
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
}

.holographic-card:hover::before {
  opacity: 1;
  transform: rotate(-45deg) translateY(100%);
}
</style>
